import React, {memo, ReactNode} from "react";
import { Box, InputAdornment, TextField, Typography } from "@mui/material";

interface Props {
    icon?: ReactNode;
    title?: string;
    size?: "small" | "medium";
    multiline?: boolean;
    variant?: "outlined" | "filled" | "standard";
    rows?: number;
    maxRows?: number;
    name: string;
    value?: string;
    defaultValue?: string;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    bgColor?: string;
    maxLength?: number;
    onChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
}

function InputField(
    { 
        icon, 
        title, 
        size, 
        multiline, 
        variant, 
        rows, 
        maxRows, 
        name, 
        value, 
        defaultValue, 
        required, 
        disabled, 
        placeholder, 
        bgColor, 
        maxLength, 
        onChange 
    }: Props) {
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();

        if (onChange) {
            onChange(event);
        }
    };

    return (
        <Box>
            {title && (
                <Typography variant="body2" gutterBottom>
                    {title}
                </Typography>
            )}
            <TextField
                required={required}
                name={name}
                placeholder={placeholder}
                variant={variant ? variant : "outlined"}
                size={size}
                defaultValue={defaultValue}
                value={value}
                onChange={handleInputChange}
                multiline={multiline}
                rows={rows}
                maxRows={maxRows}
                fullWidth
                disabled={disabled}
                slotProps={{
                    input: {
                        startAdornment: icon && (
                            <InputAdornment
                                sx={{
                                    padding: "5px",
                                }}
                                position="start"
                            >
                                {icon}
                            </InputAdornment>
                        ),
                        sx: {
                            fontSize: 'body2.fontSize',
                            backgroundColor: bgColor ? bgColor : 'background.paper',
                        },
                    },

                    htmlInput: {
                        maxLength: maxLength
                    }
                }} />
        </Box>
    );
}

export default memo(InputField);
